
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { SidebarGroup, SidebarGroupLabel, SidebarGroupContent, SidebarMenu, SidebarMenuItem } from '@/components/ui/sidebar';
import { Grid } from 'lucide-react';
import { RenameOrganizationDialog } from '@/components/organization/RenameOrganizationDialog';
import { OrganizationListProps } from './types';
import { useTranslation } from 'react-i18next';

export const OrganizationList = ({ 
  organizations,
  onWorkspaceClick,
  onBoardClick,
  onOrganizationRename
}: OrganizationListProps) => {
  const { t } = useTranslation();

  return (
    <SidebarGroup>
      <div className="flex items-center justify-between px-2 mb-2">
        <SidebarGroupLabel>{t('Organizations')}</SidebarGroupLabel>
      </div>
      <SidebarGroupContent>
        <SidebarMenu>
          {organizations?.map((org) => (
            <SidebarMenuItem key={org.id}>
              <Collapsible>
                <div className="flex items-center justify-between px-2">
                  <CollapsibleTrigger className="flex items-center gap-2 w-full py-1.5 text-sm font-semibold text-muted-foreground">
                    <div className="w-2 h-2 rounded-full" style={{ backgroundColor: org.color }} />
                    {org.name}
                  </CollapsibleTrigger>
                  <RenameOrganizationDialog
                    organizationId={org.id}
                    currentName={org.name}
                    onRename={onOrganizationRename}
                  />
                </div>
                <CollapsibleContent>
                  {org.workspaces?.map((workspace) => (
                    <Collapsible key={workspace.id}>
                      <CollapsibleTrigger 
                        className="flex items-center gap-2 w-full px-4 py-1.5 text-sm hover:bg-accent cursor-pointer"
                        onClick={() => onWorkspaceClick(workspace.id)}
                      >
                        <Grid className="h-4 w-4" />
                        <span>{workspace.name}</span>
                      </CollapsibleTrigger>
                      <CollapsibleContent className="pl-8 space-y-1">
                        {workspace.boards?.map((board) => (
                          <button
                            key={board.id}
                            onClick={(e) => onBoardClick(board.id, e)}
                            className="flex items-center gap-2 w-full px-2 py-1.5 text-sm rounded-sm hover:bg-accent text-left"
                          >
                            {board.name}
                          </button>
                        ))}
                      </CollapsibleContent>
                    </Collapsible>
                  ))}
                </CollapsibleContent>
              </Collapsible>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
};
